import TableWrapper from './tableWrapper'
export default TableWrapper
